import React from 'react';
import { Portal } from 'react-portal';
import Transition from 'react-transition-group/Transition';

class Modal extends React.Component {
  render() {
    const overlayTransition = {
      entering: {
        opacity: 0,
      },
      entered: {
        opacity: 1,
      },
      exiting: {
        opacity: 0,
      },
      exited: {
        opacity: 0,
      }
    };

    return (
      <Portal>
        <Transition
          in={this.props.visible}
          timeout={600}
        >
          {
            (state) => (
              state !== 'exited' &&
                <div
                  className="Modal__overlay"
                  style={overlayTransition[state]}
                  onClick={() => this.props.onClose()}
                >
                  <div className="Modal__body-container">
                    <div
                      className="Modal__body"
                      style={overlayTransition[state]}
                      onClick={(e) => e.stopPropagation()}
                    >
                      <button
                        className="Modal__close"
                        onClick={() => this.props.onClose()}
                      >
                        ✕
                      </button>
                      {this.props.children}
                    </div>
                  </div>
                </div>
            )
          }
        </Transition>
      </Portal>
    );
  }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/components/Modal.js